import React from 'react';
import { 
  CloseOutlined, 
  LockOutlined, 
  CheckOutlined, 
  LeftOutlined 
} from '@ant-design/icons';

export const getIcon = (iconName: string, width?: number, height?: number, color?: string) => {
  const style = { 
    fontSize: width || 16, 
    color: color || '#000000' 
  };

  switch (iconName) {
    case 'Exit':
      return <CloseOutlined style={style} />;
    case 'Lock01':
      return <LockOutlined style={style} />;
    case 'CheckIcon':
      return <CheckOutlined style={style} />;
    case 'ArrowLeft':
      return <LeftOutlined style={style} />;
    default:
      return null;
  }
}; 